import { supabase } from '../supabaseClient';

export async function getOnboardingComplete(): Promise<{
  complete: boolean;
  error: unknown;
}> {
  try {
    const { data: authData } = await supabase.auth.getUser();
    const userId = authData.user?.id;
    if (!userId) {
      return { complete: true, error: null };
    }

    const { data, error } = await supabase
      .from('profiles')
      .select('onboarding_complete')
      .eq('id', userId)
      .single();

    if (error) {
      if (error.code === '42703' || error.code === 'PGRST204') {
        return { complete: true, error: null };
      }
      console.warn('[onboardingService] getOnboardingComplete:', error.message);
      return { complete: true, error };
    }

    return { complete: Boolean(data?.onboarding_complete), error: null };
  } catch (error) {
    console.error('[onboardingService] Exception getOnboardingComplete:', error);
    return { complete: true, error };
  }
}

export async function completeOnboarding(): Promise<{ error: unknown }> {
  try {
    const { data: authData } = await supabase.auth.getUser();
    const userId = authData.user?.id;
    if (!userId) {
      return { error: new Error('Utilisateur non connecté') };
    }

    const { error } = await supabase
      .from('profiles')
      .update({ onboarding_complete: true })
      .eq('id', userId);

    if (error) {
      console.error('[onboardingService] completeOnboarding:', error);
      return { error };
    }

    return { error: null };
  } catch (error) {
    console.error('[onboardingService] Exception completeOnboarding:', error);
    return { error };
  }
}

export async function hasAnyTransaction(): Promise<boolean> {
  try {
    const { data: authData } = await supabase.auth.getUser();
    const userId = authData.user?.id;
    if (!userId) return false;

    const { data, error } = await supabase
      .from('transactions')
      .select('id')
      .eq('user_id', userId)
      .limit(1);

    if (error) {
      console.warn('[onboardingService] hasAnyTransaction:', error.message);
      return false;
    }

    return (data?.length ?? 0) > 0;
  } catch {
    return false;
  }
}
